module.exports = __webpack_public_path__ + "img/backgroundImg.fa2d5f3.png";